import { createApp } from "vue";
import App from "./App.vue";
import svgSprite from "@shared_components/svgSprite.js";
import Vue3ConfirmDialog from 'vue3-confirm-dialog';
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { recaptcha_site_key } from "./constants/envrionment";
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'


let app = createApp(App);

const mountSelector = "#freeTrialFormHolder";
const mountEl = document.querySelector(mountSelector);

if (mountEl) {
    mountEl.classList.add("free-trial-loading");
}

app.use(svgSprite)
app.use(FloatingVue)
app.use(Vue3ConfirmDialog)

app.use(VueReCaptcha, {
    siteKey: recaptcha_site_key
})

app.mount(mountSelector);

if (mountEl) {
    mountEl.classList.remove("free-trial-loading");
}